module.exports = __webpack_public_path__ + "img/sad.3ef07ce6.png";